export default {
  methods: {
    onPage (pageNames) {
      if (!Array.isArray(pageNames)) pageNames = [pageNames]
      return pageNames.includes(this.$route.name)
    }
  }
}
